import { FC } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

export const Footer: FC = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <nav className="footer-mainnav">
          <ul className="footer-mainnav__list">
            {/* <li className="footer-mainnav__item">
              <Link className="footer-mainnav__link" to="#">
                <span>О сервисе</span>
              </Link>
            </li> */}
            <li className="footer-mainnav__item">
              <Link
                className="footer-mainnav__link"
                to="https://splittest.ru/agreement"
                target="_blank"
                rel="no-referrer"
              >
                <span>Договор-оферта</span>
              </Link>
            </li>
            <li className="footer-mainnav__item">
              <Link
                className="footer-mainnav__link"
                to="https://splittest.ru/privacy.pdf"
                target="_blank"
                rel="no-referrer"
              >
                <span>Обработка информации</span>
              </Link>
            </li>
            {/* <li className="footer-mainnav__item">
              <Link className="footer-mainnav__link" to="#">
                <span>Поддержка</span>
              </Link>
            </li> */}
            <li className="footer-mainnav__item footer-mainnav__item--dev">
              <Link
                className="footer-mainnav__link"
                to="https://www.de.ru/"
                target="_blank"
                rel="no-referrer"
              >
                <span>Создано в Digital Evolution</span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};
